import {Breakpoints, Text, TextTag} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {gridUtils} from '../../../assets/css-vars/gridUtils'

const ALIGNED_LEFT_CLASS = 'IsAlignedLeft'

const DealerHighlighterContainer = styled.div`
    border-top: 2px solid ${(props) => props.theme.colors.signal.promo};
    border-bottom: 2px solid ${(props) => props.theme.colors.signal.promo};
    position: absolute;
    top: 0;
    right: 50%;
    transform: translateX(50%);
    width: 100%;
    height: calc(100% + 22px);

    &.${ALIGNED_LEFT_CLASS} {
        height: 100%;
        width: calc(112% + ${gridUtils.gap});
    }

    @media (min-width: ${Breakpoints.b560}px) {
        border: 2px solid ${(props) => props.theme.colors.signal.promo};
        width: 108%;

        &.${ALIGNED_LEFT_CLASS} {
            width: 108%;
        }
    }
`

const DealerName = styled.div`
    width: max-content;
    max-width: 90%;
    background-color: ${(props) => props.theme.colors.background.primary};
    position: absolute;
    top: -15px;
    right: 50%;
    transform: translateX(50%);
    padding: 0 ${(props) => props.theme.size.static200};

    &.${ALIGNED_LEFT_CLASS} {
        right: 0;
        left: 0;
        transform: translateX(10%);
    }

    @media (min-width: ${Breakpoints.b560}px) {
        &.${ALIGNED_LEFT_CLASS} {
            transform: translateX(25%);
        }
    }
`

interface DealerHighlighterInterface {
    dealerName: string
    alignedLeft?: boolean
}

export default function DealerHighlighter(
    props: DealerHighlighterInterface
): React.JSX.Element {
    const {t} = useTranslation('app')

    return (
        <DealerHighlighterContainer
            className={props.alignedLeft ? ALIGNED_LEFT_CLASS : ''}
        >
            <DealerName className={props.alignedLeft ? ALIGNED_LEFT_CLASS : ''}>
                <Text tag={TextTag.p}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: `${t('selectedDealer.promoAvailable')} <b>${
                                props.dealerName
                            }</b>`,
                        }}
                    />
                </Text>
            </DealerName>
        </DealerHighlighterContainer>
    )
}
